import { useCallback, useEffect, useRef } from "react";
import { ChatPollingScheduler } from "./chatPolling";

export function useChatPolling(key: string | undefined, refresh: () => Promise<void>, activity: () => number, immediate = false) {
  const activityRef = useRef(activity);
  activityRef.current = activity;
  const scheduler = useRef<ChatPollingScheduler>();
  useEffect(() => {
    if (!key) return;
    const current = new ChatPollingScheduler(refresh, () => activityRef.current());
    scheduler.current = current;
    current.start(immediate);
    return () => {
      current.stop();
      if (scheduler.current === current) scheduler.current = undefined;
    };
  }, [key, refresh, immediate]);
  const notifyActivity = useCallback(() => scheduler.current?.notifyActivity(), []);
  const resume = useCallback(() => scheduler.current?.resume(), []);
  return { notifyActivity, resume };
}
